<form [formGroup]="userForm">
  <markant-input
    *ngIf="userForm.controls['position'] as position"
    class="registration-form-input"
    id="position"
    data-cy="input-position"
    name="position"
    [showLabelHint]="true"
    [label]="'register.user.position' | transloco"
    [formControlName]="'position'"
    [error]="
      position.errors
        | formControlError: showError || position.touched || position.dirty
    "
    [errorText]="
      position.errors
        | formControlKeyError
          : 'register.user.positionValidation'
          : showError || position.touched || position.dirty
        | transloco
    "
  >
  </markant-input>
  <markant-input
    *ngIf="userForm.controls['phone'] as phone"
    class="registration-form-input"
    id="phone"
    data-cy="input-phone"
    name="phone"
    type="phone"
    [showLabelHint]="true"
    [label]="'register.user.phone' | transloco"
    [formControlName]="'phone'"
    [placeholder]="'register.user.phonePlaceholder' | transloco"
    [error]="
      phone.errors | formControlError: showError || phone.touched || phone.dirty
    "
    [errorText]="
      phone.errors
        | formControlKeyError
          : 'register.user.phoneValidation'
          : showError || phone.touched || phone.dirty
        | transloco
    "
  >
  </markant-input>
</form>
